import React, { useState } from 'react';
import colorPalette from './icons/colorPalette.png';
import { colorSelectedToStyle } from './PropsAvatar';

export const ColorPalette = ({ colorStyleID, avatarColorProps, setAvatarColorProps, listOfColors }) => {
    const [clicked, setClicked] = useState(false);

    function handleSelectedColor(e) {
        let colorChange = e.target.id;
        if (colorChange === '#fff2e6') {
            colorChange = 'light';
        }
        if (colorChange === '#804000') {
            colorChange = 'dark';
        }
        if (colorChange === '#AFEEEE') {
            colorChange = 'turqouise';
        }
        if (colorChange === '#F0E68C') {
            colorChange = 'blonde';
        }
        handleChange(colorChange);
    }

    function handleChange(color) {
        const key = colorSelectedToStyle[colorStyleID];
        const newProps = { ...avatarColorProps };
        newProps[key] = color;
        setAvatarColorProps(newProps);
        setClicked(!clicked);
    }

    function handleOptions(e) {
        setClicked(!clicked);
    };

    return (
        <>
            {clicked
                ? <div className='grid gap-1 items-center relative h-2 w-2 m-1'>
                    {listOfColors.map(
                        (item, elem) => {
                            return (
                                <div className='relative w-6 h-6 xs:w-5 xs:h-5 rounded-50 border-black border-solid border-2' key={elem} id={item}
                                    style={{
                                        backgroundColor: item,
                                    }}
                                    onClick={(e) => { handleSelectedColor(e); }}>
                                </div>
                            );
                        },
                    )}
                </div>
                : <div className='color-palette-container m-1 outline rounded-50'
                >
                    <img src={colorPalette}
                        onClick={(e) => { handleOptions(e); }}
                        className='color-palette w-8 h-8 cursor-pointer'
                    >
                    </img>
                </div>
            }
        </>
    );
};
